import { useCallback, useMemo, useState } from 'react';

type StripeCardElementKey = 'cardCvc' | 'cardExpiry' | 'cardNumber';

const createInitialReadyState = (): Record<StripeCardElementKey, boolean> => ({
  cardNumber: false,
  cardExpiry: false,
  cardCvc: false,
});

export const useStripeCardElementsReady = () => {
  const [readyByElement, setReadyByElement] = useState(createInitialReadyState);

  const resetReady = useCallback(() => {
    setReadyByElement(createInitialReadyState());
  }, []);

  const markReady = useCallback((key: StripeCardElementKey) => {
    setReadyByElement((current) => (current[key] ? current : { ...current, [key]: true }));
  }, []);

  const areCardElementsReady = useMemo(
    () => readyByElement.cardNumber && readyByElement.cardExpiry && readyByElement.cardCvc,
    [readyByElement],
  );

  const cardElementReadyHandlers = useMemo(
    () => ({
      cardNumber: () => markReady('cardNumber'),
      cardExpiry: () => markReady('cardExpiry'),
      cardCvc: () => markReady('cardCvc'),
    }),
    [markReady],
  );

  return { areCardElementsReady, cardElementReadyHandlers, resetReady };
};
